import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getTravelReasonStart,
  getTravelReasonSuccess,
  getTravelReasonFailure,
} from "../reducers/getTravelReasonReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const getTravelReason = createAsyncThunk(
  "getTravelReason",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(getTravelReasonStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/Travel/GettravelReason`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getTravelReasonSuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getTravelReasonFailure(error.response.data.Message));
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
